import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({ id: 'voice.form.header.title' }),
      subtitle: translate({ id: 'voice.form.header.subtitle' }),
    },
    alert: translate({ id: 'voice.form.alert' }),
    save: translate({ id: 'global.save' }),
    cancel: translate({ id: 'global.cancel' }),
  }))

  return api
}
